<template>
    <div ref="drop_container">
        <div ref="drop_nav" class="navItem" @blur="SetDropStatus(false)"><em>{{text}}</em></div>
        <div ref="drop_box" class="dorpBox single">
            <div class="item">
                <template v-for="(item,index) in options">
                    <a @click="SelectItem(item,index)" :key="'drop_'+index" :class="{on:selected_index==index}">{{item.title}}</a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
export default {
    props:['value','title','options'],
    data(){return{
        text:'',
        selected_index:-1
    }},
    created(){
        this.text=this.title;
        this.InitValue();
    },
    mounted(){
        var _this=this;
        $(_this.$refs.drop_container).hover(function() {
            _this.SetDropStatus(true);
        }, function() {
            _this.SetDropStatus(false);
        });
    },
    methods:{
        InitValue(){
            for (var i=0;i<this.options.length;i++){
                if (this.value==this.options[i].id){
                    if (this.options[i].id==0){
                        this.text=this.title;
                    }else{
                        this.text=this.options[i].title;
                        this.$emit('valueChange',{title:this.title,list_value:[{title:this.title,value:this.options[i].title,type:this.title,itemObj:this.options[i],id:this.options[i].id}]});
                    }
                    this.selected_index=i;
                    break;
                }
            }
        },
        SelectItem(_item,_index){
            if (_item.id==0){
                this.text=this.title;
            }else{
                this.text=_item.title;
            }
            this.selected_index=_index;
            this.$emit('input', _item.id);
            this.SetDropStatus(false);
            //通知父组件更新选中标签
            var list_value=[];
            if (_item.id>0){
                list_value.push({title:this.title,value:_item.title,type:this.title,itemObj:_item,id:_item.id});
            }
            this.$emit('valueChange',{title:this.title,list_value:list_value});
        },
        SetDropStatus(_status){
            var _this=this;
            if (_status){
                $(_this.$refs.drop_box).stop(500).fadeIn('');
                $(_this.$refs.drop_nav).addClass('curr');
            }else{
                $(_this.$refs.drop_box).stop(500).fadeOut('');
                $(_this.$refs.drop_nav).removeClass('curr');
            }
        },
        CancelTag(_item){
            if (_item.type==this.title){
                this.text=this.title;
                this.selected_index=0;
                this.$emit('input', 0);
                this.$emit('valueChange',{title:this.title,list_value:[]});
            }
        }
    },
    watch:{
        options(){
            this.InitValue();
        }
    }
}
</script>